import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getBusinessProcesses(companyId,query) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESSES, dtConfig[ModulesMap.BUSINESS_PROCESSES].getBusinessProcesses, {
		urlParams: {
			companyId,
		},
		params: query,
	})
}

function getBusinessProcessesMainInfo(companyId,query) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESSES, dtConfig[ModulesMap.BUSINESS_PROCESSES].getBusinessProcessesMainInfo, {
		urlParams: {
			companyId,
		},
		params: query,
	})
}

function getBusinessProcessesPopup(companyId, businessProcessId, query) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESSES, dtConfig[ModulesMap.BUSINESS_PROCESSES].getBusinessProcessesPopup, {
		urlParams: {
			companyId,
			businessProcessId,
		},
		params: query,
	})
}

function getBusinessProcessesPreview(companyId, businessProcessId, query) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESSES, dtConfig[ModulesMap.BUSINESS_PROCESSES].getBusinessProcessesPreview, {
		urlParams: {
			companyId,
			businessProcessId,
		},
		params: query,
	})
}

function getBusinessProcess(companyId, businessProcessId, query) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESSES, dtConfig[ModulesMap.BUSINESS_PROCESSES].getBusinessProcess, {
		urlParams: {
			companyId,
			businessProcessId,
		},
		params: query,
	})
}

function createBusinessProcess(companyId, data) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESSES, dtConfig[ModulesMap.BUSINESS_PROCESSES].createBusinessProcess, {
		urlParams: {
			companyId,
		},
		...data,
	})
}


function patchBusinessProcess(companyId, businessProcessId, data) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESSES, dtConfig[ModulesMap.BUSINESS_PROCESSES].patchBusinessProcess, {
		urlParams: {
			companyId,
			businessProcessId,
		},
		...data,
	})
}

function putBusinessProcess(companyId, businessProcessId, data) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESSES, dtConfig[ModulesMap.BUSINESS_PROCESSES].putBusinessProcess, {
		urlParams: {
			companyId,
			businessProcessId,
		},
		...data,
	})
}

function deleteBusinessProcess(companyId, businessProcessId) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESSES, dtConfig[ModulesMap.BUSINESS_PROCESSES].deleteBusinessProcess, {
		urlParams: {
			companyId,
			businessProcessId,
		},
	})
}
function createBusinessProcessCrop(companyId, data) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESSES, dtConfig[ModulesMap.BUSINESS_PROCESSES].createBusinessProcessCrop, {
		urlParams: {
			companyId,
		},
		...data,
	})
}

function patchBusinessProcessCrop(companyId, businessProcessId, data) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESSES, dtConfig[ModulesMap.BUSINESS_PROCESSES].patchBusinessProcessCrop, {
		urlParams: {
			companyId,
			businessProcessId,
		},
		...data,
	})
}

function putBusinessProcessCrop(companyId, businessProcessId, data) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESSES, dtConfig[ModulesMap.BUSINESS_PROCESSES].putBusinessProcessCrop, {
		urlParams: {
			companyId,
			businessProcessId,
		},
		...data,
	})
}

function multiSetCulture(companyId, data) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESSES, dtConfig[ModulesMap.BUSINESS_PROCESSES].multiSetCulture, {
		urlParams: {
			companyId,
		},
		...data,
	})
}

function getBusinessProcessesActiveStages(companyId, query) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESSES, dtConfig[ModulesMap.BUSINESS_PROCESSES].getBusinessProcessesActiveStages, {
		urlParams: {
			companyId,
		},
		params: query,
	})
}

function getBusinessProcessesActiveStage(companyId, activeStageId) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESSES, dtConfig[ModulesMap.BUSINESS_PROCESSES].getBusinessProcessesActiveStage, {
		urlParams: {
			companyId,
			activeStageId,
		},
	})
}

function getBusinessProcessesActiveStagePopup(companyId, activeStageId) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESSES, dtConfig[ModulesMap.BUSINESS_PROCESSES].getBusinessProcessesActiveStagePopup, {
		urlParams: {
			companyId,
			activeStageId,
		},
	})
}

function getBusinessProcessesActiveStagePreview(companyId, activeStageId) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESSES, dtConfig[ModulesMap.BUSINESS_PROCESSES].getBusinessProcessesActiveStagePreview, {
		urlParams: {
			companyId,
			activeStageId,
		},
	})
}

function getBusinessProcessesFinanceByCategories(companyId, query) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESSES, dtConfig[ModulesMap.BUSINESS_PROCESSES].getBusinessProcessesFinanceByCategories, {
		urlParams: {
			companyId,
		},
		params: query,
	})
}

function getBusinessProcessesFinanceByDestination(companyId, query) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESSES, dtConfig[ModulesMap.BUSINESS_PROCESSES].getBusinessProcessesFinanceByDestination, {
		urlParams: {
			companyId,
		},
		params: query,
	})
}

function getBusinessProcessesFinanceByWorkTypes(companyId, query) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESSES, dtConfig[ModulesMap.BUSINESS_PROCESSES].getBusinessProcessesFinanceByWorkTypes, {
		urlParams: {
			companyId,
		},
		params: query,
	})
}

function createBusinessProcessUniversal(companyId, data) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESSES, dtConfig[ModulesMap.BUSINESS_PROCESSES].createBusinessProcessUniversal, {
		urlParams: {
			companyId,
		},
		...data,
	})
}


function patchBusinessProcessUniversal(companyId, businessProcessId, data) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESSES, dtConfig[ModulesMap.BUSINESS_PROCESSES].patchBusinessProcessUniversal, {
		urlParams: {
			companyId,
			businessProcessId,
		},
		...data,
	})
}

function putBusinessProcessUniversal(companyId, businessProcessId, data) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESSES, dtConfig[ModulesMap.BUSINESS_PROCESSES].putBusinessProcessUniversal, {
		urlParams: {
			companyId,
			businessProcessId,
		},
		...data,
	})
}

export default {
	getBusinessProcesses,
	getBusinessProcessesMainInfo,
	getBusinessProcessesPopup,
	getBusinessProcessesPreview,
	getBusinessProcess,
	createBusinessProcess,
	patchBusinessProcess,
	putBusinessProcess,
	deleteBusinessProcess,

	createBusinessProcessCrop,
	patchBusinessProcessCrop,
	putBusinessProcessCrop,

	multiSetCulture,

	getBusinessProcessesActiveStages,
	getBusinessProcessesActiveStage,
	getBusinessProcessesActiveStagePopup,
	getBusinessProcessesActiveStagePreview,

	getBusinessProcessesFinanceByCategories,
	getBusinessProcessesFinanceByDestination,
	getBusinessProcessesFinanceByWorkTypes,

	createBusinessProcessUniversal,
	patchBusinessProcessUniversal,
	putBusinessProcessUniversal,
}
